import { getAllCustomers } from 'client/actions/customer'
import { navigateAddModal } from 'client/actions/navigation'
import { CompanyInterface } from 'client/Interfaces/CompanyInterface'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { l, tsxl } from 'client/Other/Translation'
import * as React from 'react'
import { connect } from 'react-redux'

import { CustomerCollectionInterface, CustomerInterface } from '../../Interfaces/CustomerInterface'
import { DocumentType } from '../../Interfaces/Draft/DraftInterface'
import Button, { ButtonType } from '../common/Button/Button'
import { CustomerAddress } from './CustomerAddress'
import { CustomerChanger } from './CustomerChange'
import { CustomerSelect } from './CustomerSelect'

export interface CustomerSelectorPropsInterface {
  documentType?: DocumentType
  customers: CustomerInterface[]
  company: CompanyInterface
  value?: CustomerInterface
  highlight?: boolean
  invalid?: boolean
  readOnly?: boolean
  customerCollection?: CustomerCollectionInterface
  containerClass?: string // CORE-2965 this is for specific purpose: scrolling page to the input field
  loadingCustomers: boolean
  openCustomerModal?: (customerName) => void
  onClickOutside?: () => void
  onChange?: (customer: CustomerInterface) => void
  showPlans?: () => void
  loadCustomers?: () => void
}

export interface OwnStateInterface {
  openCustomerSelect: boolean // this defines if the customer selection is opened.
  // When the user opens the editor, the selection should be closed.
  // When the user clicks the Change customer link, the selection should be opened
}

class CustomerSelectorClass extends React.Component<CustomerSelectorPropsInterface, OwnStateInterface> {
  constructor(props) {
    super(props)
    this.state = {
      openCustomerSelect: false,
    }
    if ((!this.props.customerCollection || !this.props.customerCollection.collection) && !this.props.loadingCustomers) {
      this.props.loadCustomers()
    }
  }

  public componentDidUpdate(prevProps) {
    if (
      this.refs.container &&
      this.props.containerClass &&
      this.props.invalid != prevProps.invalid &&
      this.props.invalid
    ) {
      this.refs.container.getElementsByTagName('input')[0].click()
      document.getElementsByClassName(this.props.containerClass)[0].scrollTop = 0
    }
  }

  private getCustomerName(item) {
    if (item) {
      return item.companyName || `${item.firstName} ${item.lastName}` || item.name
    }
  }

  public render(): JSX.Element {
    const self = this
    if (this.props.value && (this.props.value.id || this.props.value.customerId)) {
      return (
        <div className="CustomerSelector" data-automation="customer-selector-container">
          <div className="CustomerLabel">{tsxl('Customer')}</div>
          {!this.props.readOnly && (
            <CustomerChanger
              action={() => {
                self.props.onChange(null)
                this.setState({ openCustomerSelect: true })
              }}
            />
          )}
          <CustomerAddress
            company={this.props.company}
            customer={this.props.value}
            documentType={this.props.documentType}
            openCustomerModal={this.props.openCustomerModal}
          />
        </div>
      )
    } else {
      return (
        <div className="CustomerSelector" data-automation="customer-selector-container" ref="container">
          <div className="CustomerLabel">{tsxl('Customer')}</div>
          <CustomerSelect
            loadingCustomers={this.props.loadingCustomers || !this.props.customers}
            maxAllowed={
              this.props.customerCollection && this.props.customerCollection.quotaInfo
                ? {
                    limit: this.props.customerCollection.quotaInfo.total,
                    breaker: (
                      <div className="SubscribeToUnlockCustomers" key={'1'}>
                        <div className="SubscribeToUnlockCustomers__header">
                          {l('customers.subscribe-to-unlock-dropdown')}
                        </div>
                        <div className="SubscribeToUnlockCustomers__action">
                          <Button
                            type={ButtonType.link}
                            label={l('customers.view-plans-dropdown')}
                            action={this.props.showPlans}
                          />
                        </div>
                      </div>
                    ),
                  }
                : { limit: -1 }
            }
            renderItem={(item: CustomerInterface, isHighlighted) => {
              const classes = []
              if (item.unavailable) {
                classes.push('DropdownItemUnavailable')
              } else if (isHighlighted) {
                classes.push('highLightedItem')
              }
              return (
                <div className={classes.join(' ')} key={item.id || item.customerId}>
                  {this.getCustomerName(item)}
                </div>
              )
            }}
            highlight={this.props.highlight}
            onClickOutside={this.props.onClickOutside}
            customers={this.props.customers}
            preserveOrder={this.props.customerCollection && this.props.customerCollection.containsLockedCustomers}
            selected={this.props.value}
            invalid={this.props.invalid}
            onChange={(customer: CustomerInterface) => {
              if (customer && customer.unavailable) {
                return
              }
              if (self.props.onChange) {
                self.props.onChange(customer)
              }
            }}
            openCustomerModal={this.props.openCustomerModal}
            openCustomerSelect={this.state.openCustomerSelect}
            onOpen={() => this.setState({ openCustomerSelect: true })}
            onClose={() => {
              if (this.state.openCustomerSelect) {
                this.setState({ openCustomerSelect: false })
              }
            }}
          />
        </div>
      )
    }
  }
}

export const mapStateToProps = (state: StateInterface) => {
  return {
    customerCollection: state.customers,
    loadingCustomers: state.ongoing.GET_CUSTOMERS,
  }
}

const mapDispatchToProps = (dispatch) => ({
  showPlans: () =>
    dispatch(
      navigateAddModal({
        component: 'PremiumPlanModal',
      }),
    ),
  loadCustomers: () => dispatch(getAllCustomers()),
})

export const CustomerSelector = connect(mapStateToProps, mapDispatchToProps)(CustomerSelectorClass)
